/**
 * Next.js `Link` prefetch policy for marketing chrome.
 * Avoids prefetching same-page hash targets and low-intent legal routes.
 */
export function getMarketingLinkPrefetch(href: string): boolean {
	if (!href) {
		return false;
	}

	const withoutHash = href.split("#")[0] ?? href;
	const path = withoutHash.split("?")[0] ?? withoutHash;

	if (href.startsWith("#") || path === "" || path === "/") {
		if (href.includes("#")) {
			return false;
		}
	}

	if (href.startsWith("/#")) {
		return false;
	}

	if (path.includes("/legal/")) {
		return false;
	}

	if (path === "/roadmap" || path.startsWith("/roadmap/")) {
		return false;
	}

	if (path === "/waitlist" || path.startsWith("/waitlist/")) {
		return true;
	}

	if (path === "/pricing" || path.startsWith("/pricing/")) {
		return true;
	}

	if (path === "/auth/login" || path.startsWith("/auth/login/")) {
		return true;
	}

	return false;
}
